<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="`/${routerPath}/table`">回款列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <template v-if="showErrorMsg">
      <error-panel v-if="detailErrorMsg" :message="detailErrorMsg" show-back/>
    </template>
    <template v-else>
    <layout-panel>
      <template slot="header">{{$route.meta.title}}</template>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item>
              <div class="receipt-info-block">
                <h3>客户开票信息</h3>
                <span class="receipt-info"><span class="receipt-info-text">公司名称: </span>{{form.receipt_info_json.company_name}}
                  </span>
                <span class="receipt-info"><span class="receipt-info-text">开户行及账号: </span>{{form.receipt_info_json.bank_info}}
                  </span>
                <span class="receipt-info"><span class="receipt-info-text">地址及电话: </span>{{form.receipt_info_json.address_phone}}
                </span>
                <span class="receipt-info"><span class="receipt-info-text">税号: </span>{{form.receipt_info_json.tax_number}}
                </span>
              </div>
            </el-form-item>
            <el-form-item label="客户名称"
                          prop="customer_display">
              <span>{{ customer_display }}</span>
            </el-form-item>
            <el-form-item label="回款描述"
                          prop="desc">
              <span>{{form.desc}}</span>
            </el-form-item>
            <el-form-item label="收款公司"
                          prop="our_company_id">
              <span>{{ form.our_company.name }}</span>
            </el-form-item>
            <el-form-item label="收款账户"
                          prop="received_company_account">
              <span>{{ form.received_company_account.name + '/' + form.received_company_account.number }}</span>
            </el-form-item>
            <el-form-item label="回款类型"
                          prop="type">
              <span>{{ this.collectionTypeText[form.type] || '-' }}</span>
            </el-form-item>
            <el-form-item label="回款金额"
                          prop="collection_amount">
              <span>￥{{form.collection_amount | seperateThousandsToFixed(2)}}</span>
            </el-form-item>
            <el-form-item label="回款日期"
                          prop="received_date">
              <span>{{form.received_date}}</span>
            </el-form-item>
            <el-form-item label="发起人"
                          prop="creator">
              <span>{{ form.creator_name }} / {{ form.creator_id }}</span>
            </el-form-item>
            <el-form-item label="收件人"
                          prop="mail_to_text">
              <span>{{ form.mail_to_text || '无' }}</span>
            </el-form-item>
            <el-form-item label="回款备注"
                          prop="memo">
              <span>{{form.memo}}</span>
            </el-form-item>
            <el-form-item label="附件"
                      prop="attached_file">
            <div class="view-navbar">
              <ul class="clear-both">
                <li v-for="(item, index) in form.attached_file" :key="index">
                  <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                    <img v-if="item.type === 'pic' && item.pic_url" style="width: 100px; height: 100px" :src="item.pic_url | ossHost" @click="onViewImage">
                    <i v-else
                        class="sj-icon-pdf"
                        style=" font-size:100px; margin-top: 50px"
                        @click="onGetPdfFile(item, index)"></i>
                  </el-tooltip>
                </li>
              </ul>
            </div>
          </el-form-item>
          </div>
        </div>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">核销信息</template>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px">

        <div class="re-el-form__flex">
          <div class="medium" style="width: 100%">
            <el-form-item label="核销状态"
                          prop="memo">
              <span>{{receiptRelatedStatus[form.receipt_related_status]}}</span>
            </el-form-item>
            <el-form-item label="待核销金额"
                          prop="memo">
              <span>￥{{form.remain_amount_total | seperateThousandsToFixed(2)}}</span>
            </el-form-item>
            <el-form-item label="已核销金额"
                          prop="memo">
              <span>￥{{form.related_amount_total | seperateThousandsToFixed(2)}}</span>
            </el-form-item>

            <div v-for="(item, index) in form.receipt_list"
                 :key="index"
                 class="receipt-item">
              <!-- 1. 添加 title 属性用于 tooltip 显示完整内容 -->
              <!-- 2. 添加 CSS 类限制宽度并显示省略号 -->
              <span class="ellipsis w-6"
                    :title="`${index + 1}.`">{{ index + 1 }}.</span>
              <span class="ellipsis w-80"
                    :title="`${item.creator_name} 于 ${item.created_at} 关联了开票`">
                {{ item.creator_name }} 于 {{ item.created_at }} 关联了开票
              </span>
              <span class="ml-2 ellipsis w-40"
                    :title="`金额：￥${math.seperateThousandsToFixed(item.assoc_amount, 2)}`">
                金额：￥{{ math.seperateThousandsToFixed(item.assoc_amount, 2) }}
              </span>
              <router-link :to="redirectToReceiptPage(item)">
                <span class="ml-2 ellipsis w-40"
                      :title="`开票条目ID：${item.receipt_apply_id}`">
                  开票条目ID：{{ item.receipt_apply_id }}
                </span>
              </router-link>

              <template v-if="item.deleted_at">
                <span class="ellipsis w-60 deleted_info"
                      :title="`${item.deleted_by_name} 于 ${item.deleted_at} 解除了此关联关系`">
                  {{ item.deleted_by_name }} 于 {{ item.deleted_at }} 解除了此关联关系
                </span>
              </template>
              <template v-else-if="directive.financePermission()">
                <el-button size="mini"
                           type="danger"
                           class="ml-2 ellipsis w-20"
                           @click="removeAssoc(item)">取消关联
                </el-button>
              </template>
            </div>
          </div>
        </div>
      </el-form>
    </layout-panel>

    <layout-panel v-if="form.force_finish_info">
      <template slot="header">特殊核销信息</template>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px">

        <div class="re-el-form__flex">
          <div class="medium"
               style="width: 100%;">
            <div style="margin-left: 60px; margin-top: 10px; margin-bottom: 10px;">
              <span>{{ form.force_finish_info.created_at }}</span>
              <span style="margin-left: 10px">{{ form.force_finish_info.admin_name }}</span>
              <span style="margin-left: 10px">{{ form.force_finish_info.desc }}</span>
            </div>

            <el-form-item label="核销说明"
                          prop="reason">
              <span>{{ form.force_finish_info.reason }}</span>
            </el-form-item>
            <el-form-item label="附件"
                          prop="attached_file">
              <div class="view-navbar">
                <ul class="clear-both">
                  <li v-for="(item, index) in form.force_finish_info.attached_file"
                      :key="index">
                    <el-tooltip class="item"
                                effect="dark"
                                :content="item.name"
                                placement="bottom">
                      <img v-if="item.type === 'pic' && item.tmp_url"
                           style="width: 100px; height: 100px"
                           :src="item.tmp_url | ossHost"
                           @click="onViewImage">
                      <i v-else
                         class="sj-icon-pdf"
                         style=" font-size:100px; margin-top: 50px"
                         @click="onGetPdfFile(item, index)"></i>
                    </el-tooltip>
                  </li>
                </ul>
              </div>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </layout-panel>

    <router-link :to="`/${routerPath}/table`">
      <el-button type="primary">返回</el-button>
    </router-link>
    <attached-file :visible="attach_file_visible"
                   :file_title="file_title"
                   :url="attach_file_url"
                   @closeDialog="attach_file_visible = false"></attached-file>

    </template>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'viewerjs'
import downloadJS from '@/vendor/download'
import { getToken } from '@utils/auth'
import AttachedFile from '@/views/payment-manager/components/AttachedFile'
import ErrorPanel from '@components/ErrorPanel.vue'
import math from '../../../../core/filters/math'
import directive from '../../../../core/filters/directive'

export default {
  components: {
    AttachedFile,
    ErrorPanel,
  },
  mixins: [],
  data () {
    return {
      showErrorMsg: false,
      detailErrorMsg: '',
      form: {
        customerid: '',
        customer_info: {},
        receipt_info_id: null,
        receipt_info_json: {},
        desc: '',
        type: 0,
        our_company_id: '',
        our_company: {},
        received_company_account: {
          id: null,
          name: '',
          number: ''
        },
        collection_amount: '',
        received_date: '',
        mail_to: '',
        mail_to_text: '',
        memo: '',
        attached_file: [],
        receipt_related_status: '',
        related_amount_total: '',
        remain_amount_total: '',
        receipt_list: [],
        creator_id: '',
        creator_name: 0,
        force_finish_info: null,
      },
      customer_display: '无',
      attach_file_visible: false,
      file_title: '',
      attach_file_url: '',
    }
  },
  computed: {
    directive () {
      return directive
    },
    math () {
      return math
    },
    ...Vuex.mapState({
      receiptRelatedStatus: state => state.receivedPayment.receiptRelatedStatus,
      collectionTypeText: state => state.receivedPayment.collectionTypeText,
    }),

    routerPath () {
      return `received-${this.$route.meta.type}`
    },
  },
  async created () {
    this.id = this.$route.params.id
    this.id > 0 && this.setDetailData(this.id)
  },
  methods: {
    ...Vuex.mapActions([]),
    isFinancePage () {
      return this.$route.meta.type === 'approval'
    },
    redirectToReceiptPage (item) {
      if (this.isFinancePage()) {
        return `/invoice-apply/finance/detail/${item.receipt_apply_id}?type=detail&from=approve`
      }
      return `/invoice-apply/detail/${item.receipt_apply_id}?type=detail&from=approve`
    },
    setDetailData (id) {
      const params = {
        id,
        forFinance: this.isFinancePage() ? 1 : 0
      }
      request('getNewReceivedPaymentDetail', params).then(({data}) => {
        this.form = _.cloneDeep(data)
        if (Object.keys(data.customer_info).length > 0) {
          let cus = data.customer_info
          this.customer_display = cus.name + ' / ' + cus.number + ' / ' + cus.id
        }
        if (Object.keys(data.force_finish_info).length === 0) {
          this.form.force_finish_info = null
        }

        // 附件
        this.form.attached_file.forEach((file, index) => {
          if (file.type === 'pic') {
            request.common('getFinCenterFileUrl', file).then((res) => {
              this.$set(this.form.attached_file[index], 'pic_url', res.data)
            })
          }
        })
        this.showErrorMsg = false
      }).catch((e) => {
        this.detailErrorMsg = String(e).replace(/^Error:\s*/i, '')
        this.showErrorMsg = true
      })
    },
    onViewImage (event) {
      if (event.target.src) {
        this.views = new Viewer(event.target, {
          url: (image) => event.target.src,
        })
      }
      this.views.view()
    },
    onGetPdfFile (item) {
      this.$confirm('下载查看文件', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '下载',
        cancelButtonText: '查看',
        type: 'warning',
      }).then(() => {
        downloadJS(request.items.getFinCenterFileUrlForDownload(item), false, false, {
          'SJ-Auth-Token': getToken()
        })
      }).catch(action => {
        if (action === 'cancel') {
          this.tryOpenAttachFile(item)
        }
      })
    },
    tryOpenAttachFile (item) {
      if (item.type === 'pdf') {
        request.common('getFinCenterFileUrl', item).then(({data}) => {
          window.open(data)
        })
      } else if (item.type === 'eml') {
        this.attach_file_url = request.items.getFinCenterFileUrlForDownload(item)
        this.file_title = item.title
        this.attach_file_visible = true
      } else {
        this.$message({
          type: 'error',
          message: '暂不支持预览操作',
        })
      }
    },
    removeAssoc (assocItem) {
      this.$confirm(
        `警告：解除回款核销数据不可撤回，是否确定要解除？<br>
         核销人: ${assocItem.creator_name}<br>
         核销时间: ${assocItem.created_at}<br>
         核销金额: ${assocItem.assoc_amount}<br>
         开票单ID: ${assocItem.receipt_apply_id}`,
        '警告',
        {type: 'warning', dangerouslyUseHTMLString: true}).then(() => {
        this.$confirm(
          `<b style="color: red;font-size: 16px;">再次确认：确定要解除以下回款核销数据吗？</b><br>
           核销人: ${assocItem.creator_name}<br>
           核销时间: ${assocItem.created_at}<br>
           核销金额: ${assocItem.assoc_amount}<br>
           开票单ID: ${assocItem.receipt_apply_id}`,
          '再次确认',
          {type: 'warning', dangerouslyUseHTMLString: true}).then(() => {
          request.common('removeInvoiceCollectAssocApi', assocItem).then(({data}) => {
            this.$message.success('回款核销数据 解除成功')
            this.setDetailData(this.id)
          })
        })
      })
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>

.receipt-info {
  display: block;
  margin-bottom: 5px;
}

.receipt-info-text {
  font-weight: bold
}

.receipt-info-block {
  width: 470px;
  // margin-bottom: 30px;
  // margin-left: 70px;
  border-radius: 5px;
  border: 2px solid transparent;
  background-clip: padding-box;
  background-color: rgba(128, 128, 128, 0.1);
  padding: 5px 10px;
}

.view-navbar {
  right: 0px;
  bottom: 0px;
  width: 100%;
  overflow: hidden;
  display: inline;
  float: left;

  ul {
    transform: translateX(0px);
    transition: all 0.3s;
    box-sizing: content-box;
    // height: 100px;
    overflow: hidden;
    padding: 1px 0;

    li {
      float: left;
      list-style: none;
      width: 100px;
      height: 100px;
      margin-right: 5px;
      cursor: pointer;
      font-size: 0;
      line-height: 0;
      overflow: hidden;
      transition: opacity 0.15s;
    }
  }
}

.receipt-item {
  margin-left: 60px;
  margin-top: 10px;
  display: flex;
  align-items: center;

  /* 关键样式：限制宽度并显示省略号 */
  .ellipsis {
    white-space: nowrap; /* 不换行 */
    overflow: hidden; /* 超出部分隐藏 */
    text-overflow: ellipsis; /* 显示省略号 */
    display: inline-block; /* 允许设置宽度 */
  }

  .deleted_info {
    color: red;
  }

  /* Tailwind 宽度类 (可选) */
  .w-6 { width: 1.5rem; }  /* 24px */
  .w-20 { width: 5rem; }  /* 80px */
  .w-32 { width: 8rem; }  /* 128px */
  .w-36 { width: 9rem; }  /* 144px */
  .w-40 { width: 10rem; } /* 160px */
  .w-80 { width: 20rem; } /* 320px */
}

// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/received-payment/pages/ReceivedPaymentDetail.vue